import styled from 'styled-components';
var Content = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-h3wtok-0"
})(["width:100%;"]);
export default Content;